import React, { useEffect } from "react";
import { useLocation } from "@reach/router";
import AOS from "aos";
import { focusHandling } from "cruip-js-toolkit";
import { Helmet } from "react-helmet";
import orgSchema from "../orgSchema.json"; // Ensure this path is correct for your project

const DefaultPageWrapper = ({
  children,
  title = "Rho Impact | Quantify and Forecast Impact",
  description = "Powering the world's most reliable impact forecasts.",
  keywords = "avoided emissions, scope 4, avoided emissions factors, future impact, forward-looking impact, impact data, emissions data, avoided emissions data, emissions forecasting, quantifying impact, ghg emissions forecasting, impact claims, auditable impact claims, sustainability claims, esg software",
  schema = orgSchema,
  image = "/website-generic-social-image.png",
  url = "https://rhoimpact.com",
}) => {
  const location = useLocation();

  useEffect(() => {
    AOS.init({
      once: true,
      disable: "phone",
      duration: 700,
      easing: "ease-out-cubic",
    });
  }, []);

  useEffect(() => {
    document.querySelector("html").style.scrollBehavior = "auto";
    if (typeof window !== "undefined") {
      window.scroll({ top: 0 });
    }

    document.querySelector("html").style.scrollBehavior = "";
    focusHandling("outline");
  }, [location.pathname]);

  return (
    <div className="flex flex-col min-h-screen overflow-hidden bg-gradient-to-r from-rhoOffWhite-100 to-rhoTan-100">
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />

        {/* Google / search */}
        <meta itemProp="name" content={title} />
        <meta itemProp="description" content={description} />
        <meta itemProp="image" content={image} />

        {/* Facebook */}
        <meta property="og:title" content={title} />
        <meta property="og:url" content={url} />
        <meta property="og:image" content={image} />
        <meta property="og:type" content="website" />
        <meta property="og:description" content={description} />

        <meta charSet="UTF-8" />
        <meta name="keywords" content={keywords} />
        <script
          src="https://kit.fontawesome.com/41b8e02940.js"
          crossorigin="anonymous"
        ></script>
        {schema && (
          <script type="application/ld+json">{JSON.stringify(schema)}</script>
        )}
      </Helmet>
      {children}
    </div>
  );
};

export default DefaultPageWrapper;
